export default __webpack_public_path__ + "static/media/youtube.13b68cc7.png";